class QuantityButtons {
  constructor(selector = '.hulk_options_quantity') {
    this.selector = selector;
    this.init();
  }

  init() {
    this.initQuantitySelectors();
  }

  initQuantitySelectors() {
    const inputs = document.querySelectorAll(this.selector);
    inputs.forEach(input => this.wrapQuantityInput(input));
  }

  syncVisibility(input) {
    const wrapper = input.closest('.qty-wrapper');
    if (wrapper) {
      wrapper.style.display = input.style.display === 'none' ? 'none' : '';
    }
  }

  updateButtonsState(wrapper, val, min, max) {
    const minusBtn = wrapper.querySelector('.qty-minus');
    const plusBtn = wrapper.querySelector('.qty-plus');
    
    if (minusBtn) minusBtn.disabled = val <= min;
    if (plusBtn) plusBtn.disabled = max !== Infinity && val >= max;
  }

  wrapQuantityInput(input) {
    if (input.parentElement.classList.contains('qty-wrapper')) return;

    const min = parseInt(input.getAttribute('min')) || 1;
    const max = parseInt(input.getAttribute('max')) || Infinity;
    
    const wrapper = document.createElement('div');
    wrapper.className = 'qty-wrapper';
    
    const minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.className = 'qty-btn qty-minus';
    minusBtn.innerHTML = '−';
    minusBtn.setAttribute('aria-label', 'Decrease quantity');
    
    const plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.className = 'qty-btn qty-plus';
    plusBtn.innerHTML = '+';
    plusBtn.setAttribute('aria-label', 'Increase quantity');
    
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(minusBtn);
    wrapper.appendChild(input);
    wrapper.appendChild(plusBtn);
    
    this.syncVisibility(input); 

    const styleObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          this.syncVisibility(input);
        }
      });
    });
    styleObserver.observe(input, { attributes: true, attributeFilter: ['style'] });
    
    const updateButtons = () => {
      const val = parseInt(input.value) || min;
      this.updateButtonsState(wrapper, val, min, max);
    };
    
    minusBtn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const currentVal = parseInt(input.value) || min;
      if (currentVal > min) {
        input.value = currentVal - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.checkHiddenField(input);
        updateButtons();
      }
    });
    
    plusBtn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      const currentVal = parseInt(input.value) || min;
      if (currentVal < max) {
        input.value = currentVal + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.checkHiddenField(input);
        updateButtons();
      }
    });
    
    input.addEventListener('input', updateButtons);
    
    input.addEventListener('change', () => {
      let val = parseInt(input.value) || min;
      if (val < min) val = min;
      if (val > max) val = max;
      
      if (val !== parseInt(input.value)) {
        input.value = val;
      }
      
      this.updateButtonsState(wrapper, val, min, max);

      setTimeout(() => {
        this.checkHiddenField(input);
      }, 50);
    });
    
    updateButtons();
  }
  
  findHiddenFieldForInput(input) {
    const pid = input.getAttribute('data-pid');
    
    let container = input.closest('[data-pid="' + pid + '"]') || 
                    input.closest('.hulk_product_option') ||
                    input.closest('.hulk_option_wrapper');
    
    if (container) {
      const hiddenInContainer = container.querySelector('.hulk_dropdown_hidden_prop');
      if (hiddenInContainer) return hiddenInContainer;
    }
    
    const allInputs = Array.from(document.querySelectorAll('.hulk_options_quantity'));
    const allHidden = Array.from(document.querySelectorAll('.hulk_dropdown_hidden_prop'));
    
    const inputIndex = allInputs.indexOf(input);
    if (inputIndex !== -1 && inputIndex < allHidden.length) {
      return allHidden[inputIndex];
    }
    return null;
  }

  checkHiddenField(input) {
    const hiddenField = this.findHiddenFieldForInput(input);
    if (!hiddenField) return;
    
    if (hiddenField.value.includes('|')) {
      const parts = hiddenField.value.split('|');
      const hiddenQty = parts[parts.length - 1].trim();
      
      if (hiddenQty !== input.value) {
        const newValue = hiddenField.value.replace(/\|\s*\d+\s*$/, '| ' + input.value);
        hiddenField.value = newValue;
      }
    }
  }
}

(function() {
  document.addEventListener('DOMContentLoaded', ()=>{
    const hook = setInterval(()=>{
      let hulkDiv = document.querySelector('.hulkapps_product_options');
      if (hulkDiv){
        clearInterval(hook);
        new QuantityButtons();
      }
    },150)
      setTimeout(()=>{
        clearInterval(hook);
      },10000)
  });
})();